import React from 'react';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { AuthProvider } from './context/AuthContext'; 
import CSPProvider from './components/Security/CSPProvider';
import './App.css';
import Header from "./components/Header/Header";
import Footer from "./components/Footer/Footer";
import LandingPage from "./components/LandingPage/LandingPage";
// Coming Soon Mode: DogPasses import commented out until pricing is ready for public
// TODO: Uncomment when business opens and pricing is ready to be displayed
// import DogPasses from "./components/WhatWeGot/Pricing/Pricing";
import Gallery from "./components/Gallery/Gallery";
import Merchandise from "./components/WhatWeGot/Merchandise/Merchandise";
import TermsOfService from "./components/Footer/TermsOfService/TermsOfService";
import PrivacyPolicy from "./components/Footer/PrivacyPolicy/PrivacyPolicy";
import AboutUs from "./components/AboutUs/AboutUs";
import DogPark from "./components/DogPark/DogPark";
import Bar from "./components/WhatWeGot/Bar/Bar";
import Food from "./components/WhatWeGot/Food/Food";
import FAQContainer from "./components/Footer/FAQs/FAQs";
import Profile from "./components/Profile/Profile";
import Events from "./components/UpcomingEvents/Events";
import Login from "./components/Login/Login";
import Register from "./components/Login/NewAccount";
import OAuthCallback from "./components/Login/OAuthCallback";
import AccountConfirmation from './components/Login/AccountConfirmation';
import ResetPassword from './components/Login/ResetPassword';
import Rules from './components/Rules/Rules';
import DogHouseRules from './components/DogHouseRules/DogHouseRules';
// import CheckoutComplete from "./components/WhatWeGot/Pricing/CheckoutComplete/CheckoutComplete";
import ConfirmEmail from "./components/EmailConfirmationPage/EmailConfirmationPage";
import { history } from './utils/axiosInstance';

function App() {

  return (
    <Router history={history}>
      <AuthProvider>
        <CSPProvider>
        <div className="App">
          <Header />
          {/* Coming Soon Banner - Remove when business opens */}
          <div className="coming-soon-banner" style={{ 
            backgroundColor: '#ff6f61', 
            color: 'white', 
            textAlign: 'center', 
            padding: '0.75rem',
            fontWeight: '600',
            fontSize: '1.1rem',
            boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
          }}>
            🎾 Coming Soon - We're getting ready to open! 🎾
          </div>
          <div className="main-content-container">
          <Routes>
            <Route path="/" element={<LandingPage />} />
            {/* Coming Soon Mode: Dog Passes route temporarily hidden until pricing is ready for public */}
            {/* TODO: Uncomment when business opens and pricing is ready to be displayed */}
            {/* <Route path="/Dog-Passes" element={<DogPasses />} /> */}
            <Route path="/Gallery" element={<Gallery />} />
            <Route path="/Terms-of-Service" element={<TermsOfService />} />
            <Route path="/Privacy-Policy" element={<PrivacyPolicy />} />
            <Route path="/About-Us" element={<AboutUs />} />
            <Route path="/Dog-Park" element={<DogPark />} />
            <Route path="/Bar" element={<Bar />} />
            <Route path="/Food" element={<Food />} />
            <Route path="/Merchandise" element={<Merchandise />} />
            <Route path="/FAQs" element={<FAQContainer />} />
            <Route path="/Profile" element={<Profile />} />
            <Route path="/Events" element={<Events />} />
            <Route path="/Login" element={<Login />} />
            <Route path="/New-Account" element={<Register />} />
            <Route path="/oauth-callback" element={<OAuthCallback />} />
            <Route path="/confirm/:token" element={<AccountConfirmation />} />
            <Route path="/reset/:token" element={<ResetPassword />} />
            <Route path="/Rules" element={<Rules />} />
            <Route path="/Dog-House-Rules" element={<DogHouseRules />} />
            {/* <Route path="/pricing/checkout_complete" element={<CheckoutComplete />} /> */}
            <Route path="/confirm-email-change/:token" element={<ConfirmEmail />} />
          </Routes>
          </div>
          <Footer />
        </div>
        </CSPProvider>
      </AuthProvider>
    </Router>
  );
}

export default App;
